import { combineReducers } from "redux";
import { siderReducer } from "./sider/sider.reducer";
import { orgReducer } from "./org/org.reducer";
import { staffReducer } from "./staff/staff.reducer";
import { timerReducer } from "./timer/timer.reducer";
import { callerTuneReducer } from "../pages/caller-tune/slice/caller-tune.reducer";
import { globalReducer } from "./global-modals/global-modals.reducer";
import { api } from "./api/api";
import { whatsappApi } from "./api/whatsapp.api";

export const rootReducer = combineReducers({
  org: orgReducer,
  timer: timerReducer,
  sider: siderReducer,
  staff: staffReducer,
  callerTune: callerTuneReducer,
  global: globalReducer,
  [api.reducerPath]: api.reducer,
  [whatsappApi.reducerPath]: whatsappApi.reducer,
});
